export const FEATURE_TYPE_LOADING = 'FEATURE_TYPE_LOADING';
export const GET_FEATURE_TYPES_LIST = 'GET_FEATURE_TYPES_LIST';
